import React from 'react';

/* eslint-disable no-useless-escape */

export const isUrl = (str: string): boolean => {
  // Remove leading/trailing whitespace
  str = str.trim();

  // Regular URL pattern with protocol, including hash fragments and query parameters
  const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]*)?$/i;

  // Domain only pattern (for cases like blog.example.com)
  const domainPattern = /^[\w-]+(\.[\w-]+){2,}([\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]*)?$/i;

  return urlPattern.test(str) || domainPattern.test(str);
};

export const LinkifiedText = ({ text }: { text: string }) => {
  if (!text) {
    return null;
  }

  const words = text.split(' ');

  return (
    <span>
      {words.map((word, index) => {
        const isValidUrl = isUrl(word) && !word.startsWith('javascript:');

        return (
          <React.Fragment key={index}>
            {index > 0 && ' '}
            {isValidUrl ? (
              <a target='_blank' rel='noopener noreferrer' href={word.startsWith('http') ? word : `https://${word}`}>
                {word}
              </a>
            ) : (
              word
            )}
          </React.Fragment>
        );
      })}
    </span>
  );
};
